import { EXTERNAL_LINKS } from '~/lib/externalLinks'
import { useToggle } from '~/lib/hooks/useToggle'
import { useCallback, useEffect, useState } from 'react'
import { checkTermConsent, postTermConsent } from '~/api/TermsRepository'
import { snackActions } from '~/lib/snackbarHelper'
import { TermsDialog } from './component'
import { logger } from '~/lib/logger'

/**
 * 利用規約・プライバシーポリシーへの再同意が必要であるかどうかの値と、再同意が必要な場合に表示するダイアログを返す
 * （ユーザーがその他のダイアログとの表示優先度を任意に決定できるようにこの形にした）
 */
export const useTermsDialog = () => {
  const [shouldReAgree, setShouldReAgree] = useState<'loading' | boolean>('loading')
  const [open, setOpen] = useState(true)
  const [checked, toggleChecked] = useToggle(false)
  const [loading, toggleLoading] = useToggle(false)

  useEffect(() => {
    ;(async () => {
      // ユーザーが最新の利用規約に同意しているかどうか
      const { needConsentLatestTerm } = await checkTermConsent()
      setShouldReAgree(needConsentLatestTerm)
    })()
  }, [])

  const handleClose = useCallback(() => {
    setOpen(false)
  }, [])

  const handleClick = useCallback(async () => {
    toggleLoading()
    try {
      await postTermConsent()
    } catch (e) {
      logger.error(new Error('Failed to agree to terms of service', { cause: e }))
      snackActions.error('利用規約の同意に失敗しました')
    }
    handleClose()
    toggleLoading()
  }, [handleClose, toggleLoading])

  return {
    shouldReAgree,
    dialog: (
      <TermsDialog
        termsUrl={EXTERNAL_LINKS.TERMS_OF_SERVICE}
        privacyPolicyUrl={EXTERNAL_LINKS.PRIVACY_POLICY}
        open={open}
        checked={checked}
        loading={loading}
        handleChecked={toggleChecked}
        handleClick={handleClick}
      />
    ),
  }
}
